export default __webpack_public_path__ + "static/facebook-da3ea9783a3a4b704a1245b8d587f907.png";